/* eslint-disable react/no-array-index-key */
/* eslint-disable no-return-assign */
/* eslint-disable react/no-danger */
/* eslint-disable no-lonely-if */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import IconAssistente from 'assets/images/icon_assistant.svg';
import { getDocumentTypes, getLawTypes } from 'store/modules/dr_licita_store/actions';
import { getPanelProperties } from 'store/modules/panel_store/actions';
import tabId from 'services/tabId';
import {
  DocumentTypeState,
  DrLicitaState,
  LawTypeState,
} from 'store/modules/dr_licita_store/types';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { PanelState } from 'store/modules/panel_store/types';
import { SaleDrLicita } from 'pages/SaleDrLicita';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import Loader from 'components/atoms/loader';
import {
  assignUnassignBlock,
  createBlockSelection,
  createDocumentTemplate,
  exportDocument,
  fetchThesesInAssistants,
  fetchThesesKeywords,
} from 'services/actions/dr_licita_actions';
import Lottie from 'react-lottie';
import loadingAnimation from 'assets/animations/loading-bidding.json';
import createTrack from 'services/actions/tracker_actions';
import Onboarding from 'components/molecules/onboarding';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import OpenTutorial from 'components/atoms/open_tutorial';
import { useAudioRecorderController } from 'hooks/useAudioRecorderController';
import { AudioWaveRecorder } from 'components/atoms/audio_wave';
import { speechToText } from 'services/actions/chatbot_actions';
import { datatableColumns, datatableData, expandedComponent } from './datatable_list';
import { Circle, ContainerTable, ContainerText, ButtonStyles, SearchStyles, Badge } from './styles';

interface SelectType {
  value: number;
  label: string;
}
export interface ThesisKeywordType {
  id: number;
  title: string;
  block_related_words: string;
}

interface BlockInventoryType {
  id: number;
  block_objective: string;
  block_reference: string;
  block_related_words: string;
  block_text: string;
  block_text_words_list: string;
  document_type_id: number;
  law_type_id: number;
  proc_text: string;
  status: string;
  title: string;
}
interface BlockType {
  block_inventory: BlockInventoryType;
  from_keywords: boolean;
  sim_percent: number;
}

interface DocumentType {
  id: number;
  doc_text: string;
  title: string;
  created_at: string;
}

interface DocumentTemplateType {
  blocks: Array<BlockInventoryType>;
  document: DocumentType;
}

const DrLicitaCreateDocument = () => {
  const [activeStep, setActiveStep] = useState<number>(1);
  const [documentChecked, setDocumentChecked] = useState<boolean>(false);
  const [checkedBlocks, setCheckedBlocks] = useState<Array<number>>([]);
  const [documentTypesList, setDocumentTypesList] = useState<Array<SelectType>>([]);
  const [lawTypesList, setLawTypesList] = useState<Array<SelectType>>([]);
  const [documentTypesSelected, setDocumentTypesSelected] = useState<number>(0);
  const [lawTypesSelected, setLawTypesSelected] = useState<number>(0);
  const [fileSelected, setFileSelected] = useState<Array<File>>([]);
  const [textSnippet, setTextSnippet] = useState<string>('');
  const [keywords, setKeywords] = useState<string>('');
  const [showProgress, setShowProgress] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [blocksSelection, setBlocksSelection] = useState<Array<BlockType>>([]);
  const [theses, setTheses] = useState<ThesisKeywordType[]>([]);
  const [hasSelected, setHasSelected] = useState(false);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [suggestedTheses, setSuggestedTheses] = useState<ThesisKeywordType[]>([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedTopics, setSelectedTopics] = useState<string[]>([]);
  const [labelText, setLabelText] = useState('Insira um trecho do documento para análise:');
  const [placeholderText, setPlaceholderText] = useState(
    'Digite o tema para impugnação, recurso administrativo ou contrarrazões. Exemplos:\n"Atestado restritivo", "Balanço vencido", "Certidões negativas vencidas".',
  );
  const { waveRef, isRecording, startRecording, cancelRecording, stopRecording } =
    useAudioRecorderController();
  const [transcribing, setTranscribing] = useState(false);

  const [instrumentSuggestions, setInstrumentSuggestions] = useState<ThesisKeywordType[]>([]);
  const [documentTemplate, setDocumentTemplate] = useState<DocumentTemplateType>({
    blocks: [],
    document: { id: 0, doc_text: '', title: '', created_at: '' },
  });
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const { document_types, document_types_request, law_types, law_types_request } = useSelector<
    ApplicationState,
    DrLicitaState
  >((state) => state.session.dr_licita);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel, request: panelRequest } = useSelector<ApplicationState, PanelState>(
    (state) => state.session.panel,
  );

  const [refreshTour, setRefreshTour] = useState(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const dispatch = useDispatch();

  const handleFetchSuggestions = async () => {
    setLoadingSuggestions(true);
    setHasSearched(true);

    const data = {
      knowledge_base: theses,
      text_snippet: textSnippet,
    };

    const response = await fetchThesesInAssistants(data);

    if (response && response.sugestao.length > 0) {
      const suggestedIds = response.sugestao;
      const matches = theses.filter((tese) => suggestedIds.includes(tese.id));
      setSuggestedTheses(matches);
      if (matches.length === 0) {
        setHasSelected(false);
      }
      setTextSnippet('');
    } else {
      setSuggestedTheses([]);
      setHasSelected(false);
    }
    setLoadingSuggestions(false);
  };

  const handleSelectChange = (selectedOption: number) => {
    let fullText = '';
    switch (selectedOption) {
      case 1:
        fullText =
          'Digite o tema do edital que deseja impugnar. Exemplo: "Exigência de quantidade mínima de atestados para comprovação da qualificação técnica".';
        break;
      case 2:
        fullText =
          'Digite o tema da sua denúncia. Exemplo: "Empresa apresentou balanço patrimonial vencido".';
        break;
      case 3:
        fullText =
          'Digite o tema do seu pedido de esclarecimento. Exemplo: "Esclarecimento", "Ambiguidade encontrada no Edital e Termo de Referência".';
        break;
      case 4:
        fullText = 'Digite o tema sobre o qual deseja recorrer. Exemplo: "Balanço vencido".';
        break;
      case 5:
        fullText =
          'Digite o tema que deseja contestar em contrarrazões. Exemplo: "Empresa apresentou balanço patrimonial vencido".';
        break;
      case 9:
        fullText = 'Digite o tema da sua defesa. Exemplo: "Impedimento para licitar".';
        break;
      case 10:
        fullText =
          'Digite o tema sobre o qual deseja recorrer. Exemplo: "Proporcionaliade e razoabilidade na avaliação dos fatos".';
        break;
      case 11:
        fullText =
          'Digite o tema da sua denúncia. Exemplo: "Empresa apresentou balanço patrimonial vencido".';
        break;
      case 20:
        fullText =
          'Digite o tema do seu pedido. Exemplo: "Pedido de Reajuste de Preços", "Pedido de Reequilíbrio Econômico Financeiro", "Pedido de Repactuação".';
        break;
      case 22:
        fullText =
          'Digite o tema da sua cobrança administrativa. Exemplo: "cobrança", "suspensão", "atraso nos pagamentos", "extinção do contrato".';
        break;
      default:
        fullText =
          'Digite o tema para impugnação, recurso administrativo ou contrarrazões. Exemplo: "Atestado restritivo", "Balanço vencido", "Certidões negativas vencidas".';
    }

    const [label, placeholder] = fullText.split('Exemplo:');
    setLabelText(label.trim());
    setPlaceholderText(`Exemplo: ${placeholder?.trim()}`);
  };

  const checkOrUncheckBox = async (id: number) => {
    if (checkedBlocks.includes(id)) {
      if ((await assignUnassignBlock(id, 'remove')) === 'Success') {
        setCheckedBlocks(checkedBlocks.filter((element) => element !== id));
        setSelectedRows(selectedRows.filter((rowId) => rowId !== id)); // Remove do selectedRows
      }
    } else {
      if ((await assignUnassignBlock(id, 'assign')) === 'Success') {
        setCheckedBlocks([...checkedBlocks, id]);
        setSelectedRows([...selectedRows, id]);
      }
    }
  };

  const createBlock = () => {
    createBlockSelection(
      setShowProgress,
      setShowError,
      setShowSuccess,
      setBlocksSelection,
      setActiveStep,
      lawTypesSelected,
      documentTypesSelected,
      selectedTopics.length === 0 ? textSnippet : selectedTopics.join(', '),
      keywords,
      1,
      fileSelected[0],
      theses,
    );

    const documentTypeSelectedName = document_types?.find(
      (document_type) => document_type.id === documentTypesSelected,
    )?.name;

    createTrack(`Dr. Licita - Criou uma nova petição do tipo - ${documentTypeSelectedName}`);
  };

  const createDocument = () => {
    createDocumentTemplate(
      setShowProgress,
      setShowError,
      setShowSuccess,
      setActiveStep,
      setDocumentTemplate,
    );
  };

  const handleFile = async (event: any) => {
    setFileSelected(Object.values(event.target.files));
  };

  const removeAccents = (str: string): string => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
    },
    cells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
      },
    },
  };

  useEffect(() => {
    dispatch(getDocumentTypes());
    dispatch(getLawTypes());
  }, []);

  useEffect(() => {
    if (!panelRequest?.loaded && !panelRequest?.loading) {
      dispatch(
        getPanelProperties(profile?.representant ? profile?.currentCompany[tabId()] : undefined),
      );
    }
  }, [dispatch, panelRequest?.loaded, panelRequest?.loading, profile]);

  useEffect(() => {
    if (
      activeStep === 2 &&
      !hasCookie('tourStepOneDrLicitaFinished') &&
      !showProgress &&
      !showError &&
      !showSuccess
    )
      setCookie('tourStepOneDrLicitaFinished', true);

    if (activeStep === 3 && !hasCookie('tourStepTwoDrLicitaFinished')) {
      setCookie('tourStepTwoDrLicitaFinished', true);
      setRefreshTour((prev) => !prev);
    }
  }, [activeStep]);

  useEffect(() => {
    const loadTheses = async () => {
      if (documentTypesSelected > 0 && lawTypesSelected > 0) {
        const data = await fetchThesesKeywords(documentTypesSelected, lawTypesSelected);
        setTheses(data);
      }
    };
    loadTheses();
  }, [documentTypesSelected, lawTypesSelected]);

  useEffect(() => {
    if (textSnippet.length < 4) {
      setInstrumentSuggestions([]);
    }
  }, [textSnippet, theses]);

  useEffect(() => {
    setDocumentTypesList(
      document_types
        ?.filter((document_type: DocumentTypeState) =>
          [1, 2, 3, 4, 5, 9, 10, 11, 20, 22].includes(document_type.id),
        )
        .map((document_type: DocumentTypeState) => ({
          value: document_type.id,
          label: document_type.name,
        })),
    );
  }, [document_types_request.loaded, document_types]);

  useEffect(() => {
    const lawTypeTexts: { [key: number]: string } = {
      1: '(Antiga Lei de Licitações)',
      2: '(Nova Lei de Licitações)',
      22: '(Lei das Estatais)',
    };

    setLawTypesList(
      law_types?.map((law_type: LawTypeState) => {
        const description = lawTypeTexts[law_type.id]
          ? `${law_type.description} ${lawTypeTexts[law_type.id]}`
          : law_type.description;

        return { value: law_type.id, label: description };
      }),
    );
  }, [law_types_request.loaded, law_types]);

  const documentTemplateHtml = (
    <ContainerText className="border-top p-4 border-bottom">
      <h5 className="text-center mb-4">{documentTemplate.document.title}</h5>
      {documentTemplate.blocks?.map((block) => (
        <div>
          <div>{block.title}</div>
          <div
            dangerouslySetInnerHTML={{
              __html: block.block_text || '',
            }}
          />
        </div>
      ))}
    </ContainerText>
  );

  const handleRecordFinish = async (blob: Blob) => {
    const formData = new FormData();
    formData.append('audio', blob, 'audio.webm');

    try {
      setTranscribing(true);
      createTrack(`Dr. Licita - Ditar`);

      const response = await speechToText(formData);

      if (response.status === 200) {
        setTextSnippet(response.data?.text || '');
      }
    } catch (error) {
      console.error('Erro na transcrição:', error);
    } finally {
      setTranscribing(false);
    }
  };

  if (!panelRequest?.loaded || !profile?.validate_services) {
    return <Loader />;
  }

  if (!profile.can_use_dr_licita) {
    window.location.href = '/contato';
  }

  const panelValue = panel?.validate_services?.dr_licita;
  const profileValue = profile?.validate_services?.dr_licita;
  const hasAccess = panelValue !== undefined ? panelValue : !!profileValue;

  if (!hasAccess && panel?.prize?.name !== 'Dr. Licita') {
    return <SaleDrLicita />;
  }

  if (panel?.services_paralyzed?.dr_licita) {
    return (
      <div className="page-container">
        <div className="container-fluid big-resolutions">
          <div className="row mb-4 px-md-4 py-4">
            <div className="col-md-12 mb-3">
              <BlockedSubscription paralyzed />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions">
        <div className="row px-md-4 py-4">
          <div className="col-md-12 mb-2">
            <a href="/dr_licita">
              <i className="material-icons align-middle">keyboard_arrow_left</i> Voltar
            </a>
          </div>
          <div className="col-md-12">
            <div className="d-md-flex d-block align-items-center">
              <h4 className="mb-1 mr-3">Criar nova peça</h4>
              <OpenTutorial type="container" source="drlicita" />
            </div>
          </div>
        </div>
        {activeStep === 1 && !showProgress && !showError && (
          <div className="row px-md-4">
            <div className="col-12">
              <div className="card shadow p-4">
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center">
                    <Circle className="badge rounded-circle badge-dark mr-3 d-flex align-items-center justify-content-center">
                      1
                    </Circle>
                    <span className="font-weight-bold mr-2">
                      Insira as informações para criar a sua petição
                    </span>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-md-4 tour-drlicita-step-1">
                    <label htmlFor="TypeSearch" className="m-0">
                      Escolha a petição que deseja elaborar:
                    </label>
                    <div>
                      <Select
                        name="TypeSearch"
                        onChange={(selected) => {
                          handleSelectChange(selected?.value || 0);
                          setDocumentTypesSelected(selected?.value || 0);
                        }}
                        options={documentTypesList}
                        placeholder="Selecionar tipo"
                      />
                    </div>
                  </div>
                </div>
                {documentTypesSelected > 0 && (
                  <div className="row mt-1">
                    <div className="col-md-12">
                      {
                        document_types.find((document) => document.id === documentTypesSelected)
                          ?.suggestion_info
                      }
                    </div>
                  </div>
                )}
                <div className="row mt-4">
                  <div className="col-md-4 tour-drlicita-step-2">
                    <label htmlFor="lawSearch" className="m-0">
                      Selecione a legislação aplicável ao seu caso:
                    </label>
                    <div>
                      <Select
                        name="lawSearch"
                        onChange={(selected) => {
                          setLawTypesSelected(selected?.value || 0);
                        }}
                        options={lawTypesList}
                        placeholder="Selecionar lei"
                      />
                    </div>
                  </div>
                </div>
                <div className="tour-drlicita-step-3">
                  <div className="row mt-4">
                    <div className="col-12">
                      <p className="mb-1">Escolha como quer encontrar as suas teses:</p>
                      <div className="form-check form-check-inline mr-5">
                        <input
                          disabled={false}
                          className="form-check-input"
                          type="radio"
                          name="pushRadioOptions"
                          id="pushRadioKeyword"
                          onChange={() => setDocumentChecked(!documentChecked)}
                          checked={!documentChecked}
                        />
                        <label className="form-check-label" htmlFor="pushRadioKeyword">
                          Busca personalizada (Ex.: Palavras-chave, temas, artigos de lei, súmulas,
                          trechos do edital, do recurso ou da decisão)
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          disabled={false}
                          className="form-check-input"
                          type="radio"
                          name="pushRadioOptions"
                          id="pushRadioAll"
                          onChange={() => setDocumentChecked(!documentChecked)}
                          checked={documentChecked}
                        />
                        <label className="form-check-label" htmlFor="pushRadioAll">
                          Documento (arquivo em .pdf, .doc, .docx ou .txt)
                        </label>
                      </div>
                    </div>
                  </div>
                  {documentChecked && (
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <div className="form-group form-group-color">
                          <label className="my-0" htmlFor="file-upload">
                            Selecione o arquivo para referência
                          </label>
                          <input
                            className="form-control-file"
                            type="file"
                            id="file-upload"
                            onChange={handleFile}
                          />
                        </div>
                        <div className="mt-4">
                          <label>Insira o trecho que deseja buscar no edital</label>
                          <textarea
                            className="form-control"
                            id="palavras"
                            name="palavras"
                            disabled={documentTypesSelected === 0 || lawTypesSelected === 0}
                            rows={4}
                            value={keywords}
                            placeholder="Exemplo: atestado, atestados, atestado de capacidade técnica, superior, acima, quantitativo, 50%, mínimo, maior relevância"
                            onChange={(event) => setKeywords(event.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {!documentChecked && (
                    <div className="row mt-3">
                      <div className="col-md-12 textarea-container">
                        <SearchStyles>
                          <div className="d-flex justify-content-between">
                            <label htmlFor="trecho">{labelText}</label>
                            <button
                              type="button"
                              className="btn btn-link p-0 btn-sm d-flex align-items-center text-decoration-none"
                              onClick={startRecording}
                              disabled={
                                documentTypesSelected === 0 ||
                                lawTypesSelected === 0 ||
                                transcribing
                              }
                            >
                              {transcribing ? (
                                <div className="audio-loading-bars mr-2">
                                  <span />
                                  <span />
                                  <span />
                                </div>
                              ) : (
                                <i className="material-icons mr-1">mic</i>
                              )}
                              Ditar texto
                            </button>
                          </div>
                          {isRecording ? (
                            <div className="container-audio-preview mt-3">
                              <div className="flex-grow-1">
                                <AudioWaveRecorder ref={waveRef} />
                              </div>
                              <div className="d-flex align-items-center">
                                <div className="d-flex">
                                  <button
                                    type="button"
                                    className="btn d-flex align-items-center p-0 audio-cancel"
                                    onClick={cancelRecording}
                                  >
                                    <span className="material-icons">close</span>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn d-flex align-items-center p-0 audio-submit ml-1"
                                    onClick={() => stopRecording(handleRecordFinish)}
                                  >
                                    <span className="material-icons">check</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <textarea
                              className="form-control"
                              id="trecho"
                              name="trecho"
                              rows={4}
                              value={textSnippet}
                              disabled={documentTypesSelected === 0 || lawTypesSelected === 0}
                              onChange={(event) => {
                                const inputValue = event.target.value;
                                setTextSnippet(inputValue);
                                setHasSelected(false);
                                const inputWords = removeAccents(inputValue.toLowerCase()).split(
                                  /\s+/,
                                );
                                const filtered = theses.filter((item) => {
                                  const thesisText = removeAccents(item.title.toLowerCase());
                                  return inputWords.every((word) => thesisText.includes(word));
                                });
                                setInstrumentSuggestions(filtered);
                              }}
                              placeholder={placeholderText}
                              title={
                                documentTypesSelected === 0
                                  ? 'Selecione um tipo de peça jurídica'
                                  : ''
                              }
                            />
                          )}
                          <div
                            className="mt-2 d-flex align-items-center"
                            style={{ flexWrap: 'wrap' }}
                          >
                            {selectedTopics.map((topic, index) => (
                              <Badge key={index}>
                                <span className="badge badge-secondary badge-pill mr-2 mb-2 d-flex align-items-center">
                                  {topic}
                                  <button
                                    type="button"
                                    className="ml-2 close"
                                    onClick={() =>
                                      setSelectedTopics((prev) =>
                                        prev.filter((_, i) => i !== index),
                                      )
                                    }
                                  >
                                    &times;
                                  </button>
                                </span>
                              </Badge>
                            ))}
                          </div>
                          {instrumentSuggestions.length > 0 && (
                            <ul className="list-group list-group-scrollable">
                              {instrumentSuggestions.map((suggestion) => (
                                <li
                                  key={suggestion.id}
                                  className="list-group-item d-flex align-items-center"
                                >
                                  <div className="form-check aligb">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value={suggestion.title}
                                      id={`checkbox-${suggestion.id}`}
                                      onChange={(event) => {
                                        if (event.target.checked) {
                                          setSelectedTopics((prev) =>
                                            Array.from(new Set([...prev, suggestion.title])),
                                          );
                                          setKeywords((prev) => {
                                            const words = suggestion.block_related_words
                                              .split(',')
                                              .map((w) => w.trim());
                                            const existing = prev
                                              ? prev.split(',').map((w) => w.trim())
                                              : [];
                                            const merged = Array.from(
                                              new Set([...existing, ...words]),
                                            );
                                            return merged.join(', ');
                                          });
                                        } else {
                                          setSelectedTopics((prev) =>
                                            prev.filter((topic) => topic !== suggestion.title),
                                          );
                                          setKeywords((prev) => {
                                            const toRemove = suggestion.block_related_words
                                              .split(',')
                                              .map((w) => w.trim());
                                            const existing = prev
                                              ? prev.split(',').map((w) => w.trim())
                                              : [];
                                            const updated = existing.filter(
                                              (word) => !toRemove.includes(word),
                                            );
                                            return updated.join(', ');
                                          });
                                        }
                                      }}
                                    />
                                    <label
                                      className="form-check-label ml-1"
                                      htmlFor={`checkbox-${suggestion.id}`}
                                    >
                                      {suggestion.title}
                                    </label>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          )}
                          {suggestedTheses.length > 0 && (
                            <ul className="list-group list-group-scrollable">
                              {suggestedTheses.map((suggestion) => (
                                <li
                                  key={suggestion.id}
                                  className="list-group-item d-flex align-items-center"
                                >
                                  <div className="form-check aligb">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value={suggestion.title}
                                      id={`checkbox-${suggestion.id}`}
                                      onChange={(event) => {
                                        if (event.target.checked) {
                                          setSelectedTopics((prev) =>
                                            Array.from(new Set([...prev, suggestion.title])),
                                          );
                                          setKeywords((prev) => {
                                            const words = suggestion.block_related_words
                                              .split(',')
                                              .map((w) => w.trim());
                                            const existing = prev
                                              ? prev.split(',').map((w) => w.trim())
                                              : [];
                                            const merged = Array.from(
                                              new Set([...existing, ...words]),
                                            );
                                            return merged.join(', ');
                                          });
                                        } else {
                                          setSelectedTopics((prev) =>
                                            prev.filter((topic) => topic !== suggestion.title),
                                          );
                                          setKeywords((prev) => {
                                            const toRemove = suggestion.block_related_words
                                              .split(',')
                                              .map((w) => w.trim());
                                            const existing = prev
                                              ? prev.split(',').map((w) => w.trim())
                                              : [];
                                            const updated = existing.filter(
                                              (word) => !toRemove.includes(word),
                                            );
                                            return updated.join(', ');
                                          });
                                        }
                                      }}
                                    />
                                    <label
                                      className="form-check-label ml-1"
                                      htmlFor={`checkbox-${suggestion.id}`}
                                    >
                                      {suggestion.title}
                                    </label>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          )}

                          {hasSearched &&
                            !loadingSuggestions &&
                            !hasSelected &&
                            suggestedTheses.length === 0 && (
                              <div className="mt-2 text-muted">Nenhuma sugestão disponível.</div>
                            )}

                          <div className="button-container mt-2">
                            <ButtonStyles>
                              <img
                                className="px-1"
                                src={IconAssistente}
                                alt="Ícone Assistente de pesquisa"
                              />
                              <button
                                className="btn p-0 mt-2 assistente"
                                type="button"
                                onClick={() => {
                                  handleFetchSuggestions();
                                  setInstrumentSuggestions([]);
                                }}
                                disabled={loadingSuggestions || textSnippet.length < 3}
                              >
                                {loadingSuggestions ? 'Buscando...' : 'Buscar sugestões com IA'}
                              </button>
                            </ButtonStyles>
                          </div>
                        </SearchStyles>
                      </div>
                    </div>
                  )}
                </div>
                <div className="row mt-4">
                  <div className="col-md-12 d-flex justify-content-md-end">
                    <button
                      type="button"
                      disabled={
                        (documentChecked && !keywords && !fileSelected.length) ||
                        (!documentChecked && !textSnippet && selectedTopics?.length === 0)
                      }
                      className="btn btn-primary tour-drlicita-step-4"
                      onClick={() => {
                        setShowProgress(true);
                        createBlock();
                      }}
                    >
                      Próximo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep === 1 && showProgress && (
          <div className="row px-md-4">
            <div className="col-12">
              <div className="card shadow p-4">
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center">
                    <Circle className="badge rounded-circle badge-dark mr-3 d-flex align-items-center justify-content-center">
                      1
                    </Circle>
                    <span className="font-weight-bold">Processando...</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center flex-column py-5">
                    <Lottie options={defaultOptions} style={{ width: '150px', margin: '0 auto' }} />
                    <h6 className="font-weight-bold mb-0">Analisando as informações</h6>
                    <p>Aguarde isso pode levar alguns instantes</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep === 1 && showError && (
          <div className="row px-md-4">
            <div className="col-12">
              <div className="card shadow p-4">
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center">
                    <Circle className="sc-cRKLkh ficMgJ badge rounded-circle badge-danger mr-3 d-flex align-items-center justify-content-center">
                      1
                    </Circle>
                    <span className="font-weight-bold text-danger">
                      Erro ao gerar peça. Tente novamente.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep !== 1 && showSuccess && (
          <div className="row px-md-4">
            <div className="col-12">
              <div className="card shadow p-4">
                <div className="row">
                  <div className="col-md-6 d-md-flex align-items-center">
                    <Circle className="badge badge-success rounded-circle badge-success mr-3 mb-2 mb-md-0 d-flex align-items-center justify-content-center">
                      1
                    </Circle>
                    <span className="font-weight-bold text-success">
                      Documento incluído com sucesso e análise realizada.
                    </span>
                  </div>
                  <div className="col-md-6 mt-2 mt-md-0 text-md-right">
                    {activeStep === 2 && (
                      <button
                        type="button"
                        className="btn btn-link px-0"
                        onClick={() => {
                          setActiveStep(1);
                        }}
                      >
                        Refazer etapa
                      </button>
                    )}
                    {activeStep === 3 && (
                      <span className="text-secondary">
                        <em>Não é mais possível refazer essa etapa</em>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep < 2 && (
          <div className="row px-md-4 mt-4">
            <div className="col-12">
              <div className="card shadow p-4">
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center">
                    <Circle className="badge rounded-circle badge-secondary mr-3 d-flex align-items-center justify-content-center">
                      2
                    </Circle>
                    <span className="font-weight-bold text-secondary">
                      Selecione as teses que melhor se encaixam no seu caso
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep === 2 && showProgress && (
          <div className="row px-md-4">
            <div className="col-12">
              <div className="card shadow p-4">
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center">
                    <Circle className="badge rounded-circle badge-dark mr-3 d-flex align-items-center justify-content-center">
                      1
                    </Circle>
                    <span className="font-weight-bold">Processando...</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center flex-column py-5">
                    <Lottie options={defaultOptions} style={{ width: '150px', margin: '0 auto' }} />
                    <h6 className="font-weight-bold mb-0">Criando peça</h6>
                    <p>Aguarde isso pode levar alguns instantes</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep === 2 && showError && (
          <div className="row px-md-4">
            <div className="col-12">
              <div className="card shadow p-4">
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center">
                    <Circle className="sc-cRKLkh ficMgJ badge rounded-circle badge-danger mr-3 d-flex align-items-center justify-content-center">
                      1
                    </Circle>
                    <span className="font-weight-bold text-danger">
                      Erro ao gerar peça. Tente novamente.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep === 3 && (
          <div className="row px-md-4 mt-4">
            <div className="col-12">
              <div className="card shadow p-4">
                <div className="row">
                  <div className="col-md-6 d-md-flex align-items-center">
                    <Circle className="badge rounded-circle badge-success mr-3 mb-2 mb-md-0 d-flex align-items-center justify-content-center">
                      2
                    </Circle>
                    <span className="font-weight-bold text-success">Peça criada com sucesso</span>
                  </div>
                  <div className="col-md-6 mt-2 mt-md-0 text-md-right">
                    <span className="text-secondary">
                      <em>Não é mais possível refazer essa etapa</em>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep === 2 && (
          <div className="row px-md-4 mt-4">
            <div className="col-12">
              <div className="card shadow p-4">
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center">
                    <Circle className="badge rounded-circle badge-dark mr-3 d-flex align-items-center justify-content-center">
                      2
                    </Circle>
                    <span className="font-weight-bold">Selecione o conteúdo da peça</span>
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-12 tour-drlicita-step-5">
                    <ContainerTable>
                      <DataTable
                        columns={datatableColumns(
                          checkOrUncheckBox,
                          checkedBlocks,
                          setSelectedRows,
                          selectedRows,
                        )}
                        customStyles={customStyles}
                        expandableRows
                        expandableRowsComponent={expandedComponent}
                        conditionalRowStyles={[
                          {
                            when: (row) => selectedRows.includes(row.id),
                            style: {
                              backgroundColor: '#007BFF1A',
                            },
                          },
                        ]}
                        data={datatableData(blocksSelection)}
                        noDataComponent={<div className="p-5">Nenhum conteúdo encontrado.</div>}
                      />
                    </ContainerTable>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-12 text-right">
                    <button
                      type="button"
                      className="btn btn-primary tour-drlicita-step-6"
                      onClick={() => {
                        createDocument();
                      }}
                    >
                      Criar minha petição
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep !== 3 && (
          <div className="row px-md-4 mt-4 mb-4">
            <div className="col-12">
              <div className="card shadow p-4">
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center">
                    <Circle className="badge rounded-circle badge-secondary mr-3 d-flex align-items-center justify-content-center">
                      3
                    </Circle>
                    <span className="font-weight-bold text-secondary">
                      Visualize e confira sua petição pronta antes de baixar
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep === 3 && (
          <div className="row px-md-4 mt-4 mb-4">
            <div className="col-12">
              <div className="card shadow">
                <div className="row p-4">
                  <div className="col-md-12 d-flex align-items-center">
                    <Circle className="badge rounded-circle badge-dark mr-3 d-flex align-items-center justify-content-center">
                      3
                    </Circle>
                    <span className="font-weight-bold">
                      Visualize e confira sua petição pronta antes de baixar
                    </span>
                  </div>
                </div>
                <div className="tour-drlicita-step-7">{documentTemplateHtml}</div>
                <div className="row p-4">
                  <div className="col-md-12 d-flex align-items-center px-0">
                    {/* Botões de exportação */}
                    <div className="tour-drlicita-step-8">
                      <button
                        type="button"
                        className="btn btn-primary d-inline-flex align-items-center mr-2"
                        onClick={() =>
                          exportDocument(
                            documentTemplate.document.id,
                            documentTemplate.document.title,
                            'pdf',
                          )
                        }
                      >
                        <i className="material-icons" aria-hidden="true">
                          picture_as_pdf
                        </i>
                        <span className="ml-1" style={{ fontSize: '14px' }}>
                          Exportar para PDF
                        </span>
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary d-inline-flex align-items-center"
                        onClick={() =>
                          exportDocument(
                            documentTemplate.document.id,
                            documentTemplate.document.title,
                            'docx',
                          )
                        }
                      >
                        <i className="material-icons" aria-hidden="true">
                          description
                        </i>
                        <span className="ml-1" style={{ fontSize: '14px' }}>
                          Exportar para DOCX
                        </span>
                      </button>
                    </div>

                    <button
                      type="button"
                      className="btn btn-sm btn-primary d-flex align-items-center ml-auto"
                      onClick={() => (window.location.href = '/dr_licita/document')}
                    >
                      <i className="material-icons mr-1">add</i>
                      Criar nova petição
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {!hasCookie('tourStepOneDrLicita') && <Onboarding tourSelect="tourStepOneDrLicita" />}
      {hasCookie('tourStepOneDrLicitaFinished') && !hasCookie('tourStepTwoDrLicita') && (
        <Onboarding tourSelect="tourStepTwoDrLicita" />
      )}
      {refreshTour && !hasCookie('tourStepThreeDrLicita') && (
        <Onboarding tourSelect="tourStepThreeDrLicita" />
      )}
    </div>
  );
};
export default DrLicitaCreateDocument;
